export * from './router-listener.interface';
export * from './router-listener.service';
export * from './router-listener.mock';
export const ROUTER_LISTENER_SERVICE = Symbol('RouterListenerService');
